import AOS from "aos";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../assets/css/Internship.css";
import data from "../ApiUrl/meta_api.js";


function Internship() {
 const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const HomeMeta = data[0]?.Internship_page;
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  };
    useEffect(() => {
      fetchData();
      AOS.init({
        duration: 2000,
        once: true,
      });
    }, []);
  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Internship"}</title>
        <link rel="canonical" href="https://skimitaracademy.com/internship"/>
      </Helmet>{" "}
      <div
        className="backgroundCommenImage mb-5"
        style={{
          backgroundImage: `url(${require("../../assets/images/Internship/Internship.webp")})`,
        }}
      >
        {" "} 
        <div className="backgroundcommenImageBannerText"></div>
      </div>
      <div className="container mb-5">
        <h1 className="text-danger text-center">
          Internships: Gaining Practical Experience for Career Success
        </h1>
        <div className="container">
          <p className="text-dark text-justify ">
            Skimitar Hindusthan Training Institute, we offer internship
            programs that provide participants with invaluable hands-on
            experience in Industrial Automation and Digital Marketing. These
            internships are designed to bridge the gap between theoretical
            knowledge and real-world application, allowing individuals to work
            on live projects, solve industry challenges, and gain insights into
            the operational aspects of their chosen field.
          </p>
        </div>
      </div>
      <div className="container-fluid" style={{ backgroundColor: "#EBEBEB" }}>
        <div className="row Industrail_workshop1">
          <div className="col-lg-7 ">
            <h2 className="text-danger ">
              Industrial Automation Internship Program
            </h2>
           
            <p className="intershipprogram" >
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px',  }}></i>{" "}
              PLC Programming: Learn to design,
              implement, and debug PLC programs for real-world
              projects.
            </p>
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              SCADA Development: Develop and maintain real-time automation
              systems using SCADA platforms. Learn to monitor, control, and
              visualize industrial processes through effective SCADA design.
            </p>
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              HMI Interface Design: Collaborate on designing intuitive and
              user-friendly HMI.
            </p>
            
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              Embedded Systems Design and Development: Work with
              microcontrollers and embedded systems.
            </p>
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              VFD Programming & Implementation: Collaborate on the
              configuration, programming, and optimization of Variable Frequency
              Drives (VFDs).
            </p>
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              Real-World Experience: Apply theoretical knowledge to real
              projects.
            </p>
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              Industry Insight: Work closely with automation professionals and
              learn from their expertise, gaining insight into the latest
              industry trends and technologies.
            </p>
           
            <p className="intershipprogram">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", fontSize: '12px' }}></i>{" "}
              Certification: Receive a certificate upon completion of the
              internship, validating your practical skills and contributions to
              automation projects.
            </p>
          </div>

          <div className="col-lg-5">
            <img
              className="mt-4"
              alt=""
              src={require("../../assets/images/Internship/automation.webp")}
              style={{ height: "90%", width: "90%" , borderRadius: '15px' }}
            ></img>
          </div>
        </div>
      </div>

      <div className="container mt-5 mb-5">
        <h2 className="text-danger text-center">
          Digital Marketing Internship Program
        </h2>

        <p className="Marketing Workshops" style={{ textAlign: "justify" }}>
          Our Digital Marketing Internship provides hands-on experience in the
          fast-paced world of online marketing. Interns will work closely with
          experienced professionals on a variety of projects, gaining practical
          exposure to core digital marketing strategies and tools.
        </p>
      </div>
      
      <div className="container-fluid">
        <div className="row Industrail_workshop1">
          <div className="col-lg-7 ">
            <h3 className="text-danger ">Key Topics</h3>

            <p className="KeyTopics">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" , textAlign:'justify', fontSize: '12px'}}></i>{" "}
              SEO Techniques: Interns will assist in developing SEO strategies, conducting keyword research, and optimizing website content.
            </p>

            <p className="KeyTopics">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" , textAlign:'justify', fontSize: '12px'}}></i>{" "}
              Social Media Marketing: Support the creation and management of social media campaigns across various platforms.
            </p>

    

           

            <p className="KeyTopics">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" , textAlign:'justify', fontSize: '12px'}}></i>{" "}
              Practical Application: Implement learned digital marketing techniques and strategies on live projects, seeing the direct impact of your contributions.
            </p>

            <p className="KeyTopics">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545", textAlign:'justify' , fontSize: '12px'}}></i>{" "}
              Industry Tools & Platforms: Get exposure to industry-standard marketing tools and platforms, enhancing your technical proficiency.
            </p>

            <p className="KeyTopics">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" , textAlign:'justify', fontSize: '12px'}}></i>{" "}
              Professional Certification: Receive a certificate upon completing the internship, showcasing your practical knowledge and hands-on experience in digital marketing.
            </p>

            <p className="KeyTopics">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" , textAlign:'justify', fontSize: '12px'}}></i>{" "}
              Career Preparation: Build a portfolio of projects that will enhance your career prospects in the fast-growing digital marketing industry.
            </p>
          </div>

          <div className="col-lg-5">
            <img
              className="mt-4"
              src={require("../../assets/images/Internship/Digital Marketing.webp")}
              style={{ height: "90%", width: "90%", borderRadius: '15px' }}
            ></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default Internship;
